module.exports = __webpack_public_path__ + "02_cheeks.2bc073b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer3/02_cheeks.png
// module id = /EAs
// module chunks = 0